export default __webpack_public_path__ + "static/media/bb-00006.eb4e0d68.png";